import { Flex, Image, Text, useTheme } from '@chakra-ui/react';
import { formatScope } from './helpers/GoalTable.utils';
import DDLogo from './shared/assets/img/dd-small-logo.svg';
import { RightIcon } from '../icons';
import { useCallback, useState } from 'react';
import { ContributorsAndTeamsDetailsModal } from './ContributorsAndTeamsDetailsModal';

interface ScopeColumnCellProps {
  data: string[] | null;
  scope: string;
  title: string;
}

export const ScopeColumnCell = ({
  data,
  scope,
  title,
}: ScopeColumnCellProps) => {
  const { colors } = useTheme();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleModalClose = useCallback(() => {
    setIsOpen(false);
  }, [isOpen]);

  return (
    <Flex direction="column" gap={2} maxW={'136px'} overflow="hidden">
      <Flex align="center" gap={1}>
        {scope === 'ORG' && <Image src={DDLogo} alt="DD Logo" w={4} h={4} />}
        <Text color={'text.gray.300'} mt={'2px'} fontSize={'14px'}>
          {formatScope(scope)}
        </Text>
      </Flex>
      <Text color={'text.secondary2'} fontSize={'12px'}>
        {scope === 'TEAM'
          ? `Teams (${data?.length})`
          : scope === 'CONTRIBUTOR'
          ? `Members (${data?.length})`
          : ''}
      </Text>
      {scope !== 'ORG' && (
        <Flex
          align={'center'}
          gap={1}
          cursor={'pointer'}
          fontSize={'12px'}
          color={'primary'}
          onClick={() => setIsOpen(true)}
        >
          View all
          <RightIcon
            height="12px"
            width="12px"
            color={colors.primary}
            strokeWidth="3"
          />
        </Flex>
      )}
      {isOpen && (
        <ContributorsAndTeamsDetailsModal
          openDrawer={isOpen}
          handleDrawerClose={handleModalClose}
          heading={title}
          subHeading={`${
            scope === 'CONTRIBUTOR'
              ? `Members (${data?.length})`
              : `Teams (${data?.length})`
          }`}
          scope={scope}
          data={data}
        />
      )}
    </Flex>
  );
};
